module.exports = __webpack_public_path__ + "static/media/angrycat1.e481b8b6.gif";